import React from 'react';
import styled from 'styled-components';
import Text from 'components/base/Text';
import { Flex } from 'components/base/layout-components';
import Icon from 'components/base/Icon';
import { formatCypressTag } from 'common/utils/cypress.utils';

const Tab = styled(Flex)`
  cursor: pointer;
  position: relative;
`;

const IconWrapper = styled(Icon)`
  margin-right: 1rem;
`;

const DisabledDashboardTab = ({
  dashboardKey,
  dashboardName,
  iconName,
  iconColor = 'chambray'
}) => {
  const cyDashboardKey = formatCypressTag(dashboardKey);
  const clickableCyDataTag = `${cyDashboardKey}-dashboard-sidebar-select`;

  return (
    <>
      <Flex width='100%' items='center' justify='justify-between'>
        <Tab
          key={dashboardKey}
          pl='small'
          pt='normal'
          data-cy={clickableCyDataTag}
          pb='normal'
          width='100%'
        >
          <Flex items='center'>
            <Text size='large' ellipsisAfter='18rem' color='silverSand'>
              {dashboardName}
            </Text>
          </Flex>
        </Tab>
        {iconName && (
          <IconWrapper name={iconName} color={iconColor} size='normal' />
        )}
      </Flex>
    </>
  );
};

export default DisabledDashboardTab;
